import api from '../services/api';

export interface GoogleSheetsConfig {
  enabled: boolean;
  spreadsheetUrl: string | null;
}

export const googleSheetsApi = {
  getConfig: (): Promise<GoogleSheetsConfig> =>
    api.get('/google-sheets/config').then((r) => r.data),
};
